import { View } from "react-native";
import { memo } from "react";
import { IAgent } from "../../../../types/agent";

const AgentItem = ({
  agent,
  showAddress = false,
  showStatus = true,
}: {
  agent: IAgent | null;
  showAddress?: boolean;
  showStatus?: boolean;
}) => {
  if (!agent) {
    return null;
  }

  const serviceInterruption = agent.status.panic;
  return (
    <View className="flex flex-col items-start gap-1">
      <div className="flex items-center gap-2">
        <span className="font-medium text-base">{agent.name}</span>
        {showStatus && (
          <span
            className={`flex-shrink-0 text-xs px-2 py-0.5 rounded-full ${
              serviceInterruption
                ? "bg-red-100 text-red-700"
                : agent.status.mode === "active"
                  ? "bg-green-100 text-green-700"
                  : agent.status.mode === "paused"
                    ? "bg-amber-100 text-amber-700"
                    : "bg-red-100 text-red-700"
            }`}
          >
            {serviceInterruption
              ? "Service Interruption"
              : agent.status.mode === "active"
                ? "Active"
                : agent.status.mode === "paused"
                  ? "Paused"
                  : "Disabled"}
          </span>
        )}
      </div>
      {showAddress && (
        <div className="text-sm font-light text-gray-500 w-full text-start break-words">
          {agent.address}
        </div>
      )}
    </View>
  );
};

export default memo(AgentItem);
